<app-mu-table
  contextLang="massive.services"
  [columns]="tableListColumns"
  [responsive]="true"
  [flags]="flags"
  [flagEmpty]="massiveServiceFlags.LOAD_SERVICES_TABLE"
  [dataList]="dataList"
  [filters]="filters"
  [paginator]="true"
  [bodyTrTarget]="'serviceId'"
  (eventBodyTr)="ownRowActionEvent($event.value)"
>
  <ng-template appMuTableCaption>
    <div class="p-col-12 p-md-5 p-lg-4 p-xl-3">
      <app-mu-button
        label="{{ 'context.massive.services.createService' | translate }}"
        [disabled]="!dataList || !dataList.allowRoute"
        [flag]="massiveServiceFlags.CREATE_SERVICES"
        [flagList]="flags"
      ></app-mu-button>
    </div>
  </ng-template>

  <ng-template [appMuTableCell]="'idClient'" let-column let-row="row">
    <div class="ctx-idclient-cell">
      <div class="ctx-error-address" *ngIf="row.wrongAddress"></div>
      <div pTooltip="{{ column.getValue(row) }} / {{ row.orderId }}" tooltipPosition="top" class="ctx-idclient-value">
        {{ column.getValue(row) }} / <br />
        {{ row.orderId }}
      </div>
    </div>
  </ng-template>

  <ng-template [appMuTableCell]="'phone'" let-column let-row="row">
    <div pTooltip="{{ column.getValue(row) }}" tooltipPosition="top">
      {{ column.getValue(row) }}
    </div>
  </ng-template>

  <ng-template [appMuTableCell]="'address'" let-column let-row="row">
    <span class="{{ 'address_status_' + row.status }}">
      {{ column.getValue(row) }}
    </span>
  </ng-template>

  <ng-template [appMuTableCell]="'options'" let-column let-row="row" let-editor="editor">
    <app-mu-table-options
      [data]="row"
      [tableOptionList]="tableOptionList"
      [showAlways]="true"
      [checkPermissions]="false"
      [tableRowEditor]="editor"
      [actions]="actions"
    ></app-mu-table-options>
  </ng-template>

  <ng-template [appMuTableCellEditor]="'lat'" let-column let-row="row">
    <input pInputText type="text" [(ngModel)]="row[column.key]" class="ctx-cell-editor" />
    <input pInputText type="text" [(ngModel)]="row.lng" class="ctx-cell-editor" />
  </ng-template>

  <ng-template [appMuTableCellEditor]="" let-column let-row="row">
    <textarea pInputText [(ngModel)]="row[column.key]" class="ctx-cell-editor"></textarea>
  </ng-template>
</app-mu-table>
